import styled from 'styled-components';

export const Wrapper = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    padding-bottom: ${props.theme.spacing.large.l20};
  `
);

export const BlkcHead = styled.p(
  props => `
    font-size: ${props.theme.font.large.font18};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const ListWrap = styled.ul(
  props => `
    width:100%;
    padding-top: ${props.theme.spacing.small.s5};
    list-style-position: outside;
    padding-left: ${props.theme.spacing.large.l20};

    li{
      width:100%;
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.base};
      padding-bottom: ${props.theme.spacing.base};
      line-height: ${props.theme.font.lineHeight.base};

      a{
        color: ${props.theme.colors.blue.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        text-decoration: none;
      }
    }
  `
);
